import {FormattedMessage, useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {SlotCard} from './index';

export function CoverSlotCard({
  customizeStepKind = 'cover',
  isEnabled,
  registerButtonRef,
  selection,
  styles,
  onChoose,
}) {
  const intl = useIntl();
  const coverLabel = (
    <FormattedMessage defaultMessage="Cover" id="customize_panel.cover.label" />
  );
  const emptyHint = (
    <FormattedMessage
      defaultMessage="Select a material to begin"
      id="customize_panel.cover.empty_hint"
    />
  );
  const chooseAria = intl.formatMessage({
    defaultMessage: 'Choose cover',
    id: 'customize_panel.cover.choose_aria',
  });

  return (
    <SlotCard
      buttonRef={registerButtonRef}
      chooseButtonAriaLabel={chooseAria}
      className="slot-card-cover"
      emptyStateHint={emptyHint}
      isDisabled={!isEnabled}
      label={coverLabel}
      selection={selection}
      stepKind={customizeStepKind}
      styles={styles}
      onChoose={onChoose}
    />
  );
}

CoverSlotCard.displayName = 'CoverSlotCard';

CoverSlotCard.propTypes = {
  customizeStepKind: PropTypes.string,
  isEnabled: PropTypes.bool,
  registerButtonRef: PropTypes.func,
  selection: PropTypes.object,
  styles: PropTypes.object.isRequired,
  onChoose: PropTypes.func.isRequired,
};
